import { render, staticRenderFns } from "./UploadBox.vue?vue&type=template&id=64ee349f&scoped=true&"
import script from "./UploadBox.vue?vue&type=script&lang=js&"
export * from "./UploadBox.vue?vue&type=script&lang=js&"
import style0 from "./UploadBox.vue?vue&type=style&index=0&id=64ee349f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee349f",
  null
  
)

export default component.exports